// extracted by mini-css-extract-plugin
export default {"container":"LanguageSwitch_container__cnxip","select":"LanguageSwitch_select__kMiA7","icon":"LanguageSwitch_icon__Kt+gV","switch__item":"LanguageSwitch_switch__item__WVkqh"};